import { format } from "date-fns";

// Company name first; otherwise first name, plus last name when there is one.
// Shared by every export so customers / suppliers are named the same way.
export function formatPartyName(companyName, firstName, lastName) {
  const company = (companyName || "").trim();
  if (company) return company;
  return [firstName, lastName]
    .map((part) => (part || "").trim())
    .filter(Boolean)
    .join(" ");
}

// Header info + file name shared by the PDF and Excel of one export, e.g.
//   fileName:    "Invoice_Approved_2026-10-01_to_2026-10-31"
//   dateRange:   "Oct 1, 2026 - Oct 31, 2026"
//   statusLabel: "Approved (Approved, Partially Collected, Collected)"
// `status` is one entry of an export config's `statuses`.
export function buildExportMeta(title, status, from, to) {
  const includes = status.includes || [];
  return {
    title,
    status: status.label,
    fileName: `${title.replace(/\s+/g, "_")}_${status.label}_${format(
      from,
      "yyyy-MM-dd",
    )}_to_${format(to, "yyyy-MM-dd")}`,
    dateRange: `${format(from, "MMM d, yyyy")} - ${format(to, "MMM d, yyyy")}`,
    statusLabel:
      includes.length > 1
        ? `${status.label} (${includes.join(", ")})`
        : status.label,
  };
}
